module.exports = __webpack_public_path__ + "img/gntech_thumbnail.cbbeda87.jpg";